import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import { Tooltip, OverlayTrigger, Badge, Button } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import swal from "sweetalert2";
import idly from '../../../../images/product/break_box.png';
import lunch from '../../../../images/product/meals_box.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { addDays, subDays } from 'date-fns';
import moment from 'moment';
import axios from 'axios';
import ChangeProductDetails from '../../../modal/Subscription_Management/Manage_Subscriptions/ChangeProductDetails';
import { useLocation } from 'react-router-dom';
import Location from '../../../modal/Subscription_Management/Manage_Subscriptions/Location';
import { useNavigate } from 'react-router-dom';
import SpecialCase from '../../../modal/Subscription_Management/Manage_Subscriptions/SpecialCase';

const ConvertSubscriber = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const subscriptionID = queryParams.get('data');
    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };


    // get lead details
    const [lead_name, setname] = useState('');
    const [mobile_no, setMobileno] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [areaID, setAreaID] = useState(null);
    const [gst_percentage, setgst_percentage] = useState(0);

    // subscriber name
    const [subscriber_name, setsubscriber] = useState('');
    const [subscriber_mobile, setSubscriberMobile] = useState('');
    const [subscriber_address, setSubscriberAddress] = useState('');

    // product details
    const [person_name, setpersonName] = useState('');
    const [delivery_contact, setdeliverycontact] = useState('');
    const [delivery_address, setdeliveryaddress] = useState('');
    const [delivery_latitude, setdeliveryLatitude] = useState('');
    const [delivery_longitude, setdeliveryLongitude] = useState('');
    const [latitude, setlatitude] = useState('');
    const [longitude, setlongitude] = useState('');
    const [locationUrl, setLocationUrl] = useState('');
    const [errors, setErrors] = useState({});

    const fetchleaddetails = async () => {
        try {
            const response = await axios.get(`${baseURL}/leadsubscription/${subscriptionID}`);
            setname(response.data.data.delivery_person_name);
            setsubscriber(response.data.data.delivery_person_name);
            setpersonName(capitalizeFirstLetter(response.data.data.delivery_person_name));
            setMobileno(response.data.data.delivery_contact_number);
            setSubscriberMobile(response.data.data.delivery_contact_number);
            setdeliverycontact(response.data.data.delivery_contact_number);
            setAddress(response.data.data.address);
            setSubscriberAddress(response.data.data.address);
            setdeliveryaddress(response.data.data.address);
            setCity(response.data.data.area);
            setAreaID(response.data.data.area);
            setdeliveryLatitude(response.data.data.latitude);
            setdeliveryLongitude(response.data.data.longitude);
            setlatitude(response.data.data.latitude);
            setdeliveryLatitude(response.data.data.latitude);
            setlongitude(response.data.data.longitude);
            setLocationUrl(response.data.data.location_url);
        } catch (error) {
            console.log('Error fetching data', error);
        }
    };

    useEffect(() => {
        fetchleaddetails();

        axios.get(`${baseURL}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setgst_percentage(parseFloat(response.data.data.gst));
                } else {
                    console.log("Unexpected API response structure:", response);
                    setgst_percentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setgst_percentage(5);
            });
    }, []);

    const [lead_id, setlead_id] = useState(null);
    const [subscriber_id, setSubscriber_id] = useState(null);
    const [productdata, setProductdata] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [subtotal, setsubtotal] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [description, setDescription] = useState('');
    const [gstType, setGstType] = useState('exclusive'); // or 'inclusive'

    const fetchdata = async () => {
        try {
            const response = await axios.get(`${baseURL}/leadsubscription/product/${lead_id}`);
            setProductdata(response.data.data);
            // setProductrelation(response.data.data.productrelation);
            setHasFetched(true);

            const totalAmount = response.data.data.reduce((sum, product) => {
                // Convert product_amount to a number and add it to the sum
                const amount = parseFloat(product.product_amount) || 0; // Ensure it doesn't break on invalid data
                return sum + amount;
            }, 0);
    
            setsubtotal(totalAmount);

            const gstValue = totalAmount * (gst_percentage / 100);
            setGst(gstValue); // Store the GST value

            // Calculate total amount (subtotal + GST)
            const total = totalAmount + gstValue;
            setTotalAmount(total); // Store the total amount

        } catch (error) {
            console.log('Error fetching data', error);
            setHasFetched(true);
        }
    };

    useEffect(() => {
        if (gst_percentage > 0) {
            fetchdata();
        }
    }, [gst_percentage, lead_id]);

    const fetchids = async () => {
        axios.get(`${baseURL}/subscriber/details/${subscriber_mobile}`)
            .then(response => {
                setSubscriber_id(response.data.subscriber_id);
                setlead_id(response.data.lead_id);
            })
            .catch(error => {
                console.log("error fetching ids");
            });
    };

    useEffect(() => {
        if(subscriber_mobile) {
            fetchids();
        }
    }, [subscriber_mobile]);


    const formatDate = (date) => {
        if (date) {
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = months[d.getMonth()];
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        } else {
            return '';
        }
    };

    const [isaddressChecked, setIsAddressChecked] = useState(false);
    const handleaddressCheckboxChange = (e) => {
        setIsAddressChecked(e.target.checked);
    };

    // package dropdown
    const [packageoptions, setPackageoption] = useState([]);
    const [selectedpackage, setSelectedpackage] = useState(null);
    const [itemCategoryIds, setItemCategoryIds] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
            const response = await axios.get(`${baseURL}/dropdown/package`);
            const formatted = response.data.data.map(item => ({
                value: item.sno,
                label: item.package_name + ' ( ' + item.timeline_name + ' ' + item.timeline_days + ' days )',
                days_count: item.timeline_days,
                name: item.package_name,
                timeline_name: item.timeline_name,
                sunday: item.sunday,
                monday: item.monday,
                tuesday: item.tuesday,
                wednesday: item.wednesday,
                thursday: item.thursday,
                friday: item.friday,
                saturday: item.saturday,
                all_days: item.all_days,
                product: item.products_id,
                timeline: item.products_timeline,
                amount: item.selling_amount,
                item_category_list: item.item_category_list,
            }));
            setPackageoption(formatted);
            } catch (error) {
            console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // onchange package
    const handlepackagechange = (selectedOption) => {
        setSelectedpackage(selectedOption);
        if (startDate) {
            calculateEndDate(selectedOption, startDate, holidays);
        }
        if (selectedOption) {
            try {
                // Parse the JSON string into an array
                const parsedList = JSON.parse(selectedOption.item_category_list);

                // Extract item_category_id values
                const ids = parsedList.map(item => item.item_category_id);

                // Set in state
                setItemCategoryIds(ids);
            } catch (error) {
                console.log('Failed to parse item_category_list:', error);
            }
        }
    };

    // special case item
    const [itemsoption, setitemoptions] = useState([]);
    const [replaceitemopt, setReplace] = useState([]);
    const [selectedItem, setSelecteditem] = useState(null);
    const [replaceditem, setReplacedItem] = useState(null);
    const [reason, setreason] = useState('');
    const [specialCaseData, setSpecialCaseData] = React.useState(null);
    // selected item replace on change
    const handleSelectChange = (selected) => {
        setSelecteditem(selected);

        // Remove selected item from replaceitemopt
        setReplace(itemsoption.filter(item => item.value !== selected.value));
    };

    useEffect(() => {
        console.log(itemCategoryIds);
        if (itemCategoryIds.length>0) {
            const postData = {category_ids: itemCategoryIds}
            axios.post(`${baseURL}/dropdown/items_by_categories`, postData)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.name,
                }));
                setitemoptions(formatted);
                setReplace(formatted);
            }).catch(error => {
                console.log(error);
            });
        }
    }, [itemCategoryIds]);

    // special case checkbox
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    // start date
    const [startDate, setStartDate] = useState(null);
    const [startDateopt, setStartDateopt] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDateopt(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            // console.log(formattedDate);
            setStartDate(formattedDate);
            if (selectedpackage) {
                calculateEndDate(selectedpackage, formattedDate, holidays);
            }
        } else {
            setStartDate(null);
        }
    };

    // Holiday array
    const [holidays, setHolidays] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getholiday`);
                setHolidays(response.data.data);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // end date calculation
    const [endDate, setEndDate] = useState(null);
    const calculateEndDate = (timeline, startDate, holidays = []) => {
        // console.log(timeline);
        const all_days = timeline.all_days;
        const days_count = timeline.days_count;
        let sunday, monday, tuesday, wednesday, thursday, friday, saturday;
        if ( all_days === 1) {
            sunday = timeline.sunday;
            monday = timeline.monday;
            tuesday = timeline.tuesday;
            wednesday = timeline.wednesday;
            thursday = timeline.thursday;
            friday = timeline.friday;
            saturday = timeline.saturday;
        } else {
            sunday = '0';
            monday = '0';
            tuesday = '0';
            wednesday = '0';
            thursday = '0';
            friday = '0';
            saturday = '0';
        }

        // Create a days array that represents the days of the week (0 = Sunday, 6 = Saturday)
        const daysOfWeek = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
        // console.log(daysOfWeek);
    
        let currentDate = moment(startDate);
        let validDaysCount = 0;
    
        // Loop until we've counted the required days (excluding invalid ones like Sundays)
        while (validDaysCount < days_count) {
            // console.log(validDaysCount, days_count);

            // Check if the current day is valid to count (i.e., its value is 1)
            const currentDayOfWeek = currentDate.day();

            const currentDateStr = currentDate.format('YYYY-MM-DD');

            const isHoliday = holidays.includes(currentDateStr);
            const isValidDay = daysOfWeek[currentDayOfWeek] === '0';
            // console.log(currentDateStr, isHoliday, isValidDay);

            if (isValidDay && !isHoliday) {
                validDaysCount++;
            }
            
            // if (daysOfWeek[currentDayOfWeek] === '0') {
            //     validDaysCount++;
            // }
    
            // Move to the next day
            currentDate.add(1, 'days');
            // console.log(currentDate);
        }
        const endDate = currentDate.format('YYYY-MM-DD');
        setEndDate(endDate);
    };

    // payment mode dropdown
    const [paymentmode, setPaymode] = useState([]);
    const [transactionId, setTransactionId] = useState('');
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isVisible, setIsVisible] = useState(false);  
    useEffect(() => {
        const fetchpaymode = async () => {
            try {
            const response = await axios.get(`${baseURL}/paymentmode/getactive`);
            const formatted = response.data.map(item => ({
                value: item.sno,
                label: item.paymentmode_name,
                transaction_id: item.transaction_id,
            }));
            setPaymode(formatted);
            } catch (error) {
            console.log('Error fetching lead types:', error);
            }
        };

        fetchpaymode();
    }, []);

    // payment mode onchange
    const handlePaymentChange = (selectedOption) => {
        setSelectedPayment(selectedOption.value);
        setIsVisible(selectedOption?.transaction_id === 0); // Show field only if transaction_id is 0
    };

    // area dropdown
    const [areaOption, setAreaOption] = useState([]);
    const [selectedArea, setSelectedArea] = useState(null);
    
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id}});
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if(areaOption && areaID){
        setSelectedArea(areaOption.find(data => data.value === areaID));
        }
    }, [areaID, areaOption]);

    // product count
    const orderBlog = [
        { id: 1, number: 1 },
    ];
    const reducer = (previousState, updatedState) => ({
        ...previousState,
        ...updatedState,
    });
    const [selectedNumber, setSelectedNumber] = useState(1);
    const [state, setState] = useReducer(reducer, { orderBlog: orderBlog });
    const handleCountAdd = (id) => {
        let temp = state.orderBlog.map((data) => {
            if (id === data.id) {
                const newNumber = data.number + 1;
                setSelectedNumber(newNumber); // update selected number
                return { ...data, number: newNumber };
            }
            return data;
        });
        setState({ orderBlog: temp });
    };
    const handleCountMinus = (id) => {
        let temp = state.orderBlog.map((data) => {
            if (id === data.id) {
                const newNumber = data.number > 1 ? data.number - 1 : data.number;
                setSelectedNumber(newNumber); // update selected number
                return { ...data, number: newNumber };
            }
            return data;
        });
        setState({ orderBlog: temp });
    };

    const handleClear = () => {
        setSelectedpackage(null);
        setStartDate(null);
        setreason('');
        setStartDateopt(null);
        setEndDate(null);
        setState({ orderBlog: [{ id: 1, number: 1 }] });
        setAreaID(null);
        setSelectedArea(null);
        setSelectedNumber(1);
        setpersonName('');
        setdeliverycontact('');
        setdeliveryaddress('');
        setdeliveryLatitude('');
        setdeliveryLongitude('');
        setLocationUrl('');
        setIsChecked(false);
        setReplacedItem(null);
        setSelecteditem(null);
    };

    // soft refresh page
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchdata();
    }

    // ---------------------------------------- add product------------------

    const validate = () => {
        const newErrors = {};
        newErrors.valid = true;
        if (!selectedpackage) {
            newErrors.pack = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.pack = "";
        }
        

        if (!startDate) {
            newErrors.sdate = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.sdate = "";
        }

        if (!person_name) {
            newErrors.pname = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.pname = "";
        }

        if (!delivery_contact) {
            newErrors.dcontact = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.dcontact = "";
        }

        if (!delivery_address) {
            newErrors.daddrs = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.daddrs = "";
        }

        if (!selectedArea) {
            newErrors.area = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.area = "";
        }

        if(!locationUrl){
            newErrors.loc = "This Field is Required.";
            newErrors.valid = false;
        } else if (!delivery_latitude) {
            newErrors.loc = "Not a Valid Location URL";
            newErrors.valid = false;
        } else {
            newErrors.loc = "";
        }

        // if(isChecked){
        //     if(!selectedItem){
        //         newErrors.item = "This Field is Required.";
        //         newErrors.valid = false;
        //     } else {
        //         newErrors.item = "";
        //     }

        //     if(!replaceditem){
        //         newErrors.reitem = "This Field is Required.";
        //         newErrors.valid = false;
        //     } else {
        //         newErrors.reitem = "";
        //     }
        // }

        if(!subscriber_name) {
            newErrors.subs_name = "This Field is Required."
            newErrors.valid = false;
        } else {
            newErrors.subs_name = "";
        }

        if(!subscriber_mobile) {
            newErrors.subs_mob = "This Field is Required."
            newErrors.valid = false;
        } else {
            newErrors.subs_mob = "";
        }

        if(!subscriber_address) {
            newErrors.subs_addrs = "This Field is Required."
            newErrors.valid = false;
        } else {
            newErrors.subs_addrs = "";
        }
        
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            console.log(validationErrors);
            setErrors(validationErrors);
            if (!validationErrors.valid){
                return;
            }
        }

        const postData = {
            branch_id: branch_id,
            subscriber_name: subscriber_name,
            subscriber_mobile: subscriber_mobile,
            subscriber_address: subscriber_address,
            // lead: leadId,
            // lead_name: lead_name,
            // lead_mobile_no: mobile_no,
            // lead_email_id: email_id,
            delivery_person_name: person_name,
            delivery_contact_number: delivery_contact,
            latitude: delivery_latitude,
            longitude: delivery_longitude,
            locationUrl: locationUrl,
            product: selectedpackage.product,
            timeline: selectedpackage.timeline,
            package: selectedpackage.value,
            product_amount: selectedpackage.amount,
            product_count: selectedNumber,
            start_date: startDate,
            end_date: endDate,
            address: delivery_address,
            // delivery_point: dpoint,
            area: areaID || city,
            created_by: user_id,
            location_url: locationUrl,
            is_special_case: isChecked ? 1 : 0,
            // item: isChecked ? selectedItem.value : null,       // e.g., 1
            // replaceitem: isChecked? replaceditem.value : null, // e.g., 5
            special_case: isChecked ? specialCaseData : null
        }

        axios.post(`${baseURL}/subscriber/convert_subscriber`, postData)
            .then(response => {
                softRefresh();
                fetchids();
                setSelectedpackage(null);
                setStartDate(null);
                setStartDateopt(null);
                setreason('');
                setEndDate(null);
                setState({ orderBlog: [{ id: 1, number: 1 }] });
                setlatitude(delivery_latitude);
                setlongitude(delivery_longitude);
                setSelectedNumber(1);
                setIsChecked(false);
                setReplacedItem(null);
                setSelecteditem(null);
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
            });
    };

    // location details
    const [latLng, setLatLng] = useState(null);

    // Extract lat/lng from pasted URL
    const extractLatLngFromUrl = (url) => {
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
            setdeliveryLongitude(match[2]);
            setdeliveryLatitude(match[1]);
            return {
                lat: parseFloat(match[1]),
                lng: parseFloat(match[2]),
            };
        }
        return null;
    };

    useEffect(() => {
        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (coords) {
                setLatLng(coords);
                setErrors(prevErrors => ({ ...prevErrors, loc: "" }));
            } else {
                setLatLng(null);
                setErrors(prevErrors => ({ ...prevErrors, loc: "Not a Valid Location URL." }));
            }
        }
    }, [locationUrl]);

    // new payment pre reqs
    const [paymentMode, setPaymentMode] = useState(null);
    const [amount, setAmount] = useState(null);
    const [collectedDate, setCollectedDate] = useState(null);
    const handleCollectDateChange = (date) => {
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            // console.log(formattedDate);
            setCollectedDate(formattedDate);
        } else {
            setCollectedDate(null);
        }
    };

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "paging": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        // ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    
    // edit product
    const [selectedId, setSelecctedID] = useState("");
    const Change_product_details = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("ChangeProductDetails");
        setOpen(true);
    };
    

    // delete product
    const DeleteModal = (data) => {
        swal.fire({
            html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose one Product
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <p class="text-center"><b>${data.product_name} - ${data.timeline_name}( ${data.timeline_days} Days )</b></p>
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                <defs>
                                    <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#5987dd"/>
                                        <stop offset=".118" stop-color="#638bd6"/>
                                        <stop offset=".316" stop-color="#7d98c3"/>
                                        <stop offset=".572" stop-color="#a8aba3"/>
                                        <stop offset=".871" stop-color="#e3c678"/>
                                        <stop offset="1" stop-color="#ffd364"/>
                                    </radialGradient>
                                    <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                                </defs>
                                <g id="_27-feel_bad" data-name="27-feel bad">
                                    <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                    <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                    <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                    <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="34" cy="22" r="1"/>
                                    <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="16" cy="22" r="1"/>
                                    <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                    <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                    <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                    <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                    <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                    <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                    <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                    <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                    <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                    <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                    <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                                </g>
                            </svg>
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
            axios.delete(`${baseURL}/leadsubscription/${data.sno}`)
                .then((result) => {
                    // window.location.reload();
                    softRefresh();
                });
            }
        });
    };

    // delete all
    const DeleteAllModal = (productdata) => {
        swal.fire({
            html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose all Product
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        ${productdata.map(data => `
                            <p class="text-center" key=${data.sno}>
                                <b>${data.product_name} - ${data.timeline_days} Days</b>
                            </p>
                        `).join('')}
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                <defs>
                                    <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#5987dd"/>
                                        <stop offset=".118" stop-color="#638bd6"/>
                                        <stop offset=".316" stop-color="#7d98c3"/>
                                        <stop offset=".572" stop-color="#a8aba3"/>
                                        <stop offset=".871" stop-color="#e3c678"/>
                                        <stop offset="1" stop-color="#ffd364"/>
                                    </radialGradient>
                                    <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                                </defs>
                                <g id="_27-feel_bad" data-name="27-feel bad">
                                    <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                    <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                    <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                    <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="34" cy="22" r="1"/>
                                    <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="16" cy="22" r="1"/>
                                    <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                    <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                    <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                    <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                    <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                    <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                    <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                    <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                    <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                    <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                    <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                                </g>
                            </svg>
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // Create an array of delete promises
                const deletePromises = productdata.map(data =>
                    axios.delete(`${baseURL}/leadsubscription/${data.sno}`)
                );

                // Wait for all deletes to complete
                Promise.all(deletePromises)
                .then(() => {
                    softRefresh(); // call once after all deletes done
                })
                .catch(error => {
                    console.error('Error deleting some products:', error);
                });
            }
        });
    };

    const duplicate = (id) => {
        axios.post(`${baseURL}/leadsubscription/duplicate/${id}`)
            .then(response => {
                softRefresh();
                handleClear();
                // window.location.reload();
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
            });
    };

    const [showInput, setShowInput] = useState(false);
    const [coupon, setCoupon] = useState('');

    const handleIconClick = () => {
        setShowInput(true);
    };


    // view location
    const handleModalLocation = () => {
        setModalType("Location");
        setOpen(true);
    };

    const [couponamount, setcouponamount] = useState(0);
    const [couponID, setcouponId] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const handleApplyClick = () => {
        // You can handle the coupon logic here
        // console.log('Coupon applied:', coupon);

        if (!coupon) {
            setErrorMessage('Coupon Code is Required.');
            setTimeout(() => setErrorMessage(''), 5000);
            setShowInput(false);
            return;
        }

        const filter = {
            coupon_code: coupon || '',
            coupon_for: 0
        }

        axios.get(`${baseURL}/coupon/code`, {params: filter})
            .then(response => {
                // console.log(response);
                if (response.data.data) {
                    let datas = response.data.data;
                    setcouponId(datas.sno);
                    if (datas.coupon_type === 0){
                        // console.log(datas.coupon_value);
                        setcouponamount(parseFloat(datas.coupon_value));
                        setTotalAmount(parseFloat(subtotal + gst - parseFloat(datas.coupon_value)));
                    } else if (datas.coupon_type === 1) {
                        let percentage = parseFloat(datas.coupon_value);
                        let val = parseFloat(subtotal * parseFloat(percentage / 100));
                        // console.log(val);
                        setcouponamount(val);
                        setTotalAmount(parseFloat(subtotal + gst - val));
                    }
                } else {
                    setcouponamount(0);
                    setShowInput(false);
                    setErrorMessage('Coupon not valid or expired');
                    // Clear error message after 5 seconds
                    setTimeout(() => setErrorMessage(''), 5000);
                    setcouponId(null);
                    
                }
                setShowInput(false);
            })
            .catch(error => {
                setcouponamount(0);
                setShowInput(false);
                console.log('There was an error fetching the data!', error);
                setErrorMessage('Error fetching coupon. Please try again.');
                setTimeout(() => setErrorMessage(''), 5000);
                setcouponId(null);
            });
    };


    // crerate Subscription
    const handleSubmitSubscription = () => {
        const productsnoList = productdata.map(item => item.sno).join(',');
        const totalScore = productdata.reduce((sum, item) => {
            const score = item.timelinerelation?.score || 0; // use 0 if undefined/null
            return sum + score;
        }, 0);

        let pay_sts = 1;
        console.log(totalAmount, amount);
        if (Number(totalAmount) === Number(amount)) {
            pay_sts = 0;
        }

        let balance = Number(totalAmount) - Number(amount);

        const postData = {
            lead: lead_id,
            subscriber_id: subscriber_id,
            branch_id: branch_id,
            products: productsnoList,
            payment_mode: paymentMode,
            payment_mode_label: paymentMode ? 'Cash' : null,
            transaction_id: transactionId,
            sub_total: subtotal,
            gst: gst,
            gst_type: gstType === 'exclusive' ? 0 : 1,
            total_amount: totalAmount,
            coupon_amount: couponamount,
            paid_amount: Number(amount),
            paid_date: collectedDate,
            coupon_id: couponID,
            description: description,
            score: totalScore,
            created_by: user_id,
            payment_process: pay_sts,
            balance_amount: balance,
        }

        axios.post(`${baseURL}/subscriber/activate_subscriber`, postData)
            .then(response => {
                // window.location.href = '../manage-subscriptions';
                navigate('/manage-subscriptions', {
                    state: { toastMessage: 'Subscribed & Converted Successfully!', toastType: 'success' }
                });
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
                navigate('/manage-lead', {
                    state: { toastMessage: 'Error Converting Customer', toastType: 'error' }
                });
            });
    };

    // Add Subscription
    const [errorsubs, setErrorsubs] = useState({});
    const validatesubs = () => {
        const newErrors = {};
        newErrors.valid = true;
        if (productdata.length <= 0) {
            newErrors.prod = "Add Products to Subscribe";
            newErrors.valid = false;
        } else {
            newErrors.prod = "";
        }
        
        // if (!selectedPayment) {
        //     newErrors.paymode = "This Field is Required.";
        //     newErrors.valid = false;
        // } else {
        //     newErrors.paymode = "";
        // }
        
        // if (isVisible) {
        //     if (!transactionId){
        //         newErrors.trans = "This Field is Required.";
        //         newErrors.valid = false;
        //     } else {
        //         newErrors.trans = "";
        //     }
        // }

        if (paymentMode === null) {
            newErrors.paymode = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.paymode = "";
        }

        const enteredAmount = parseFloat(amount);
        const maxAmount = parseFloat(totalAmount);
        if (!amount) {
            newErrors.amount = 'This Field is Required.';
            newErrors.valid = false;
        } else if (isNaN(enteredAmount)) {
            newErrors.amount = 'Invalid amount';
            newErrors.valid = false;
        } else if (enteredAmount > maxAmount) {
            newErrors.amount = 'Amount cannot be greater than Total Amount';
            newErrors.valid = false;
        } else {
            newErrors.amount = '';
        }

        if (!collectedDate) {
            newErrors.collectedDate = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.collectedDate = "";
        }

        return newErrors;
    };

    const ConfirmationModalSinglePackage = (event) => {
        event.preventDefault();
        const validationErrors = validatesubs();
        if (Object.keys(validationErrors).length > 0) {
            setErrorsubs(validationErrors);
            if (!validationErrors.valid){
                return;
            }
        }

        swal.fire({
            html: `
                <div class="alert alert-success px-2 py-2" role="alert">
                    Are you sure you want to create a subscription package?
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>

                <div class="row mb-2 text-center">
                    <label class="text-black"><b>${lead_name} - ${mobile_no}</b></label>
                </div>

                <div class="row mt-3">
                    <label class='col-lg-12 d-flex justify-content-start text-black font-w400 fs-6 mb-4'>
                        <span class='text-danger font-w500'>Product Details</span>
                    </label>
                    <div class='col-lg-12 text-black font-w400 fs-7 mb-1'>
                        ${productdata.map(data => `
                            <div class="row">
                                <div class="col-lg-9 d-flex justify-content-start">
                                    <span class='text-primary font-w500'>${data.product_name}</span> &nbsp;
                                    <span>(${data.timeline_name} ${data.timeline_days})</span>
                                </div>
                                <div class="text-black fw-semibold fs-7 col-lg-3">
                                    <i class="fa-solid fa-indian-rupee-sign me-2"></i>${data.product_amount}
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                <hr>
                <div class="row mb-2 mt-3">
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-5">Sub Total</div>
                            <div class="text-black fw-semibold fs-4">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${subtotal}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-6">
                                <label class="mb-0">Discount</label>
                                <span class="text-danger fw-bold ms-1"></span>
                            </div>
                            <div class="text-black fw-semibold fs-5">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${couponamount ? couponamount : 0}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-6">
                                <label class="mb-0">GST</label>
                                <span class="text-danger fw-bold ms-1">(${gst_percentage}%)</span>
                            </div>
                            <div class="text-black fw-semibold fs-5">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${gst}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <label class="text-black fw-semibold fs-4">Total Amount</label>
                            <div class="text-danger fw-bold fs-3">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${totalAmount}
                            </div>
                        </div>
                </div>   
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubmitSubscription();
            }
        });
    };

    const handleSpecialCaseSave = (jsonString) => {
        console.log("Received special case JSON:", jsonString);
        setSpecialCaseData(jsonString);

        // You can now use this data in your payload or API call
    };

    const handleSpecialCase = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);

        if (checked) {
            setModalType("SpecialCase");
            setOpen(true);
        } else {
            setOpen(false);
            setSpecialCaseData(null);  // Clear the data when unchecked
        }
    };

    const handleSpecialCaseCancel = () => {
        console.log("Received special case Cancell");
        setIsChecked(false);
        setOpen(false);

    };

    useEffect(() => {
        let calculatedGst = 0;
        let netSubtotal = subtotal - couponamount;

        if (gstType === 'exclusive') {
            // GST is added on top of subtotal
            calculatedGst = (netSubtotal * gst_percentage) / 100;
            setGst(calculatedGst.toFixed(2));
            setTotalAmount((netSubtotal + calculatedGst).toFixed(2));
            setAmount((netSubtotal + calculatedGst).toFixed(2));
        } else {
            // GST is included in subtotal
            calculatedGst = netSubtotal - (netSubtotal / (1 + gst_percentage / 100));
            setGst(calculatedGst.toFixed(2));
            setTotalAmount(netSubtotal.toFixed(2));
            setAmount(netSubtotal.toFixed(2));
        }
    }, [subtotal, couponamount, gst_percentage, gstType]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Convert Subscriber</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Subscriber Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-subscribers'>Manage Subscriber</Link></li>
                    </ol>
                </div>
                <div className='d-flex flex-column align-items-start justify-content-end py-1'>
                    <div className='d-flex flex-row align-items-start gap-2'>
                        <label className='text-black fs-5 font-w500'>{capitalizeFirstLetter(lead_name)}</label>
                        <span>-</span>
                        <label className='text-primary fs-5 font-w500'>{mobile_no}</label>
                        <span className='align-content-center'>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">View Location</span> </Tooltip>}>
                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={()=> handleModalLocation()} >
                                    <span><i class="fa-solid fa-map-location-dot fs-4  text-danger"></i></span>
                                </Button>
                            </OverlayTrigger>
                        </span>
                    </div>
                    <div className='bg-dark py-2 px-2 rounded text-wrap'>
                        <label className='text-white fs-5 font-w500 '>{address}</label>
                    </div>
                </div>
            </div>

            <>
                {open && modalType === "ChangeProductDetails" && (
                    <ChangeProductDetails show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={softRefresh} name={lead_name} mobile={mobile_no} />
                )}
                {open && modalType === "Location" && (
                    <Location show={open} onClose={() => setOpen(false)} lat={latitude} long={longitude} />
                )}
                {open && modalType === "SpecialCase" && (
                    <SpecialCase show={open} onClose={() => setOpen(false)} itemCategoryIds={itemCategoryIds} selectedpackage={selectedpackage} onSave={handleSpecialCaseSave} oncancel={handleSpecialCaseCancel}/>
                )}
            </>

            <div className='row mb-2'>
                {/* subscriber details */}
                <div className="col-lg-12 mb-2 d-flex flex-row align-items-center justify-content-between">
                    <label className='mb-0 text-danger font-w600 fs-3'>Subscriber Details</label>
                    <label className="text-black font-w500 fs-7">
                        <input
                            type="checkbox"
                            onChange={handleaddressCheckboxChange}
                            className="form-check-input me-2 mt-0 mb-2"
                            id="customCheckBox1"
                            checked={isaddressChecked}
                        />
                        Custom Address
                    </label>
                </div>
                <div className='col-lg-12'>
                    <div className='row'>
                        <div className="col-lg-4 mb-3">
                            <label className="text-black font-w500 fs-7">Subscriber Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Subscriber Name" 
                                value={subscriber_name}
                                maxLength={100}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setsubscriber(formatName(onlyAlphabets));
                                }}
                            />
                            {errors.subs_name && <div className="text-danger fs-8 mt-1">{errors.subs_name}</div>}
                        </div>
                        <div className="col-lg-4 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile Number<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Mobile Number" 
                                value={subscriber_mobile} disabled
                            />
                            {errors.subs_mob && <div className="text-danger fs-8 mt-1">{errors.subs_mob}</div>}
                        </div>
                        <div className="col-lg-4 mb-3">
                            <label className="text-black font-w500 fs-7">Delivery Address<span className="required">*</span></label>
                            <textarea className="form-control" row={'1'} placeholder="Enter Delivery Address" 
                                value={subscriber_address}
                                disabled={!isaddressChecked}
                                maxLength={250}
                                onChange={(e) => setSubscriberAddress(formatName(e.target.value))} 
                            />
                            {errors.subs_addrs && <div className="text-danger fs-8 mt-1">{errors.subs_addrs}</div>}
                        </div>
                    </div>
                </div>

                {/* product details */}
                <div className="col-lg-4 border-end mb-2">
                   <div className='row'>
                        <div className='text-center mb-3'>
                            <div className="text-danger font-w600 fs-3 mt-3">
                                <label className='mb-0'>Product Details</label>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <div className='row px-3 py-4'>
                                {/* package */}
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Package<span className="required">*</span></label>
                                    <Select placeholder='Select Package'
                                        value={selectedpackage}
                                        onChange={handlepackagechange}
                                        options={packageoptions}
                                    />
                                    {errors.pack && <div className="text-danger fs-8 mt-1">{errors.pack}</div>}
                                </div>

                                {/* lead */}
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Customer Name<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Customer Name" 
                                        maxLength={100}
                                        value={person_name}
                                        onChange={(e) => {
                                            const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                            setpersonName(formatName(onlyAlphabets));
                                        }}
                                    />
                                    {errors.pname && <div className="text-danger fs-8 mt-1">{errors.pname}</div>}
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Mobile Number<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Mobile Number" 
                                        maxLength={10}
                                        value={delivery_contact} 
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                            setdeliverycontact(onlyNums);
                                        }}
                                    />
                                    {errors.dcontact && <div className="text-danger fs-8 mt-1">{errors.dcontact}</div>}
                                </div>

                                {/* address */}
                                <div className="col-lg-12 mb-3">
                                    <label className="text-black font-w500 fs-7">Delivery Address<span className="required">*</span></label>
                                    <textarea className="form-control h-auto" row={'3'} placeholder="Enter Delivery Address" 
                                        maxLength={250}
                                        value={delivery_address} 
                                        onChange={(e) => setdeliveryaddress(formatName(e.target.value))} 
                                    />
                                    {errors.daddrs && <div className="text-danger fs-8 mt-1">{errors.daddrs}</div>}
                                </div>

                                {/* location url */}
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Location URL <span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Paste Google Maps location URL" value={locationUrl} onChange={(e) => setLocationUrl(e.target.value)}/>
                                    {errors.loc && <div className="text-danger fs-8 mt-1">{errors.loc}</div>}
                                </div>

                                

                                {/* {isChecked  && (
                                    <>
                                        <div className="col-lg-6 mb-3">
                                            <label className="text-black font-w500 fs-7">Selected Item<span className="required">*</span></label>
                                            <Select
                                                placeholder="Select Item"
                                                onChange={handleSelectChange}
                                                options={itemsoption}
                                            />
                                            {errors.item && <div className="text-danger fs-8 mt-1">{errors.item}</div>}
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="text-black font-w500 fs-7">Replacement Item<span className="required">*</span></label>
                                            <Select
                                                placeholder="Select Item"
                                                options={replaceitemopt}
                                                onChange={(selected) => {
                                                    setReplacedItem(selected);
                                                }}
                                            />
                                            {errors.reitem && <div className="text-danger fs-8 mt-1">{errors.reitem}</div>}
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <label className="text-black font-w500 fs-7">Reason</label>
                                            <textarea className="form-control h-auto" row={'3'} placeholder="Enter Reason" 
                                                maxLength={200}
                                                value={reason}
                                                onChange={(e) => setreason(e.target.value)}
                                            />
                                        </div>
                                    </>
                                )} */}

                                {/* date */}
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker placeholder='Select Date'
                                            minDate={addDays(new Date(), 1)} // Only allow dates from tomorrow onward
                                            format="DD-MM-YYYY"
                                            value={startDateopt}
                                            onChange={handleStartDateChange}
                                        />
                                    </div>
                                    {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className=' input-group-text border-0 px-0 bg-gray-200 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker placeholder='Select Date'
                                            value={endDate && moment(endDate).format('DD-MM-YYYY')}
                                            format="DD-MM-YYYY"
                                            disabled
                                        />
                                    </div>
                                </div>

                                {/* area */}
                                <div className='col-lg-12 mb-3'>
                                    <label className="text-black font-w500 fs-7">Area<span className="required">*</span></label>
                                    <Select
                                        options={areaOption}
                                        value={selectedArea}
                                        onChange={(e) => {
                                            setAreaID(e.value);
                                            setCity(e.value);
                                            setSelectedArea(e);
                                        }}
                                    />
                                    {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                                </div>

                                {/* special case */}
                                {selectedpackage && (
                                <div className="col-lg-12 mb-3">
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={handleSpecialCase}
                                        className="form-check-input me-3"
                                        id="customCheckBox1"
                                    />
                                    <label className="text-black fs-6 font-w500 mb-3" htmlFor="customCheckBox1">Special Case</label>
                                </div>
                                )}
                            </div>
                            {selectedpackage && (
                                <div className='row'>
                                    <div className="col-lg-6 mb-4 text-center">
                                        <label className="text-black font-w500 fs-6">Amount</label>
                                        <div className='mt-2'>
                                            <label className="text-danger font-w600 fs-3">
                                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{selectedpackage? selectedpackage.amount : 0}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-4 text-center">
                                        <label className="text-black font-w500 fs-6">Product Count<span className="required">*</span></label>
                                        {state.orderBlog.map((item, index) => (
                                            <div className="mt-2" key={index}>
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <div className="quntity">
                                                        <button data-decrease onClick={() => handleCountMinus(item.id)}>-</button>
                                                        <input data-value type="text" value={item.number} />
                                                        <button data-increase onClick={() => handleCountAdd(item.id)}>+</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-lg-12 d-flex align-items-center justify-content-center gap-3 mb-3">
                                        <Link onClick={handleSubmit} className="btn btn-sm btn-primary mb-2">Add Product</Link>
                                        <Link onClick={handleClear} className="btn btn-sm btn-secondary mb-2">Clear</Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Plan Details & Transaction Details */}
                <div className='col-lg-8 mb-2'>

                    {/* plan details */}
                    {productdata.length>0 ? (
                        <>
                            <div className='row mb-2'>
                                <div className='text-center'>
                                    <div className="text-danger font-w600 fs-3 mt-3">
                                        <label className='mb-0'>Plan Details</label>
                                    </div>
                                </div>
                                {productdata.length > 1 && (
                                    <div className='text-end mb-1 pb-1 pe-2'>
                                        <Badge bg="none" className='fs-7 px-2 py-1 border border-info text-info' style={{ cursor: 'pointer'}} onClick={() => DeleteAllModal(productdata)}>Clear All</Badge>
                                    </div>
                                )}
                            </div>
                            <div className='row mh-500px scroll-y'>
                                {productdata.map((data, index) => (
                                    <div className='col-lg-12 mb-2'>
                                        <div className="d-flex p-3 align-items-center justify-content-center gap-2 border border-warning bg-warning-light">
                                            <LightGallery
                                                onInit={onInit}
                                                speed={500}
                                                plugins={[lgThumbnail, lgZoom]}
                                            >
                                                <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : idly} className='rounded px-1 py-0'>
                                                    <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : idly} alt={data.product_name} className='cursor-pointer w-100px h-90px' />
                                                </div>
                                            </LightGallery>
                                            <div className='row'>
                                                <label className='text-black font-w400 fs-5'>
                                                    <span className='text-primary font-w500'>{data.product_name}</span>
                                                    <span > ( {data.timeline_name} {data.timeline_days} days ) </span>
                                                </label>
                                                <label className='d-block text-black  font-w500 fs-6'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Date</span></Tooltip>} >
                                                        <i className='fa-solid fa-user  text-black  fs-6 me-2'></i>
                                                    </OverlayTrigger>
                                                    <span>{capitalizeFirstLetter(data.delivery_person_name)}</span>
                                                    <span> - </span>
                                                    <span>{data.delivery_contact_number}</span>
                                                </label>
                                                <label className='d-block text-black  font-w500 fs-6'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Date</span></Tooltip>} >
                                                        <i className='fa-solid fa-calendar-days  text-black  fs-6 me-2'></i>
                                                    </OverlayTrigger>
                                                    <span>{formatDate(data.start_date)}</span>
                                                    <span> to </span>
                                                    <span>{formatDate(data.end_date)}</span>
                                                </label>
                                                <label className='d-block text-gray-800  font-w500 fs-7'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Area</span></Tooltip>} >
                                                        <i class="fas fa-map-marker-alt  text-black fs-7 me-2"></i>
                                                    </OverlayTrigger>
                                                    <span className='me-4'>{data.area_name}</span>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivery point</span></Tooltip>} >
                                                        <i class="fas fa-crosshairs  text-black   fs-7 me-2"></i>
                                                    </OverlayTrigger>
                                                    <span>{data.deliverypoint_name}</span>

                                                </label>
                                                <label>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Address</span></Tooltip>} >
                                                        <i class="fas fa-map-pin text-black fs-7 me-2"></i>
                                                    </OverlayTrigger>
                                                    <span>{data.address ? data.address : '-'}</span>
                                                </label>
                                            </div>
                                            <div className='row mb-3'>
                                                <label className="d-block text-danger font-w600 fs-5">
                                                    <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{data.product_amount}</span>
                                                </label>
                                                <label class="d-flex me-3 text-end">
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1" onClick={() => Change_product_details(data.sno)}>
                                                            <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1" onClick={() => DeleteModal(data)}>
                                                            <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger>

                                                </label>
                                                <div className='d-block'>
                                                    <div className="" key={index}>
                                                        <div className="d-flex align-items-center justify-content-lg-between">
                                                            <div className="quntity">
                                                                <button data-decrease >-</button>
                                                                <input data-value type="text" value="1" readOnly/>
                                                                <button data-increase onClick={() => duplicate(data.sno)}>+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ):(
                        <>
                            <div className='text-center mb-3'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Plan Details</label>
                                </div>
                            </div>

                            <div className='card border border-warning text-center h-300px d-flex justify-content-center align-items-center'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                    <defs>
                                        <radialGradient
                                            id="radial-gradient"
                                            cx="-27.957"
                                            cy="8.563"
                                            r="6"
                                            gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop offset="0" stopColor="#5987dd" />
                                            <stop offset=".118" stopColor="#638bd6" />
                                            <stop offset=".316" stopColor="#7d98c3" />
                                            <stop offset=".572" stopColor="#a8aba3" />
                                            <stop offset=".871" stopColor="#e3c678" />
                                            <stop offset="1" stopColor="#ffd364" />
                                        </radialGradient>
                                        <style>
                                            {`.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}`}
                                        </style>
                                    </defs>
                                    <g id="_27-feel_bad" data-name="27-feel bad">
                                        <circle cx="24" cy="24" r="23" style={{ fill: "#ffce52" }} />
                                        <ellipse cx="24" cy="17" rx="18" ry="15" style={{ fill: "url(#radial-gradient)" }} />
                                        <path
                                            className="cls-3"
                                            d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"
                                        />
                                        <ellipse className="cls-4" cx="33" cy="23" rx="3" ry="4" />
                                        <ellipse className="cls-5" cx="33" cy="23" rx="2" ry="3" />
                                        <circle className="cls-6" cx="34" cy="22" r="1" />
                                        <ellipse className="cls-4" cx="15" cy="23" rx="3" ry="4" />
                                        <ellipse className="cls-5" cx="15" cy="23" rx="2" ry="3" />
                                        <circle className="cls-6" cx="16" cy="22" r="1" />
                                        <path
                                            className="cls-5"
                                            d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"
                                        />
                                        <path className="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z" />
                                        <path
                                            className="cls-5"
                                            d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"
                                        />
                                        <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style={{ fill: "#3bc5f6" }} />
                                        <path
                                            d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z"
                                            style={{ fill: "#00a3e1" }}
                                        />
                                        <path
                                            className="cls-3"
                                            d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"
                                        />
                                        <ellipse className="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)" />
                                        <ellipse className="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)" />
                                        <ellipse className="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)" />
                                        <ellipse className="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)" />
                                        <ellipse className="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)" />
                                    </g>
                                </svg>

                                <label className="text-info font-w600 fs-1 ms-1">No Plan Details</label>
                            </div>

                        </>
                    )}

                    {/* transaction details */}
                    <div className='row mb-4'>

                        {/* transac details */}
                        <div className='col-lg-6'>
                            <div className='text-center mb-4'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Transaction Details</label>
                                </div>
                            </div>
                            
                            {/* old payment */}
                            <div className='row mb-2 d-none'>
                                <div className='col-lg-12 mb-4'>
                                    <label className="text-black font-w500 fs-7">Payment Mode<span className="required">*</span></label>
                                    <Select
                                        placeholder="Select Mode"
                                        options={paymentmode}
                                        menuPlacement='top'
                                        onChange={handlePaymentChange}
                                    />
                                </div>
                                {isVisible && (
                                    <div className="col-lg-12 mb-4">
                                        <label className="text-black font-w500 fs-7">Transaction ID<span className="required">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Transaction ID" 
                                            maxLength={500}
                                            value={transactionId} 
                                            onChange={(e) => setTransactionId(e.target.value)}
                                        />
                                        <span className='text-danger'>{errorsubs.trans}</span>
                                    </div>
                                )}
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Description</label>
                                    <textarea className="form-control" placeholder="Enter Description" />
                                </div>
                            </div>
                            {/* old payment */}

                            <div className='row mb-2'>
                                <div className='col-lg-12 mb-4'>
                                    <label className="text-black font-w500 fs-5">Payment Mode <span className="required">*</span></label>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input  className="form-check-input" type="radio" name="paymentMode" id="online" value="0" checked={paymentMode === 0} onChange={(e) => setPaymentMode(0)}/>
                                            <label className="form-check-label fs-7 font-w600 text-black" htmlFor="online">Online</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="paymentMode" id="offline" value="1" checked={paymentMode === 1} onChange={(e) => setPaymentMode(1)}/>
                                            <label className="form-check-label fs-7 font-w600 text-black" htmlFor="offline">Offline</label>
                                        </div>
                                    </div>
                                    <span className='text-danger'>{errorsubs.paymode}</span>
                                </div>

                                {/* online */}
                                {paymentMode === 0 && (
                                    <>
                                        <div className="col-lg-12 mb-4">
                                            <label className="text-black font-w500 fs-7">Payment Amount<span className="required">*</span></label>
                                            <input type="number" className="form-control" placeholder="Enter Amount"
                                                maxLength={10}
                                                value={amount} 
                                                onChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                    setAmount(onlyNums);
                                                }}
                                            />
                                            <span className='text-danger'>{errorsubs.amount}</span>
                                        </div>

                                        <div className="col-lg-12 mb-3">
                                            <label className="text-black font-w500 fs-7">Schedule Date<span className="required">*</span></label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                <DatePicker placeholder='Select Date'
                                                    minDate={new Date().setHours(23, 59, 59, 999)}
                                                    maxDate={addDays(new Date().setHours(23, 59, 59, 999), 15)}
                                                    format="DD-MM-YYYY"
                                                    onChange={handleCollectDateChange}
                                                />
                                            </div>
                                            <span className='text-danger'>{errorsubs.collectedDate}</span>
                                        </div>
                                    </>
                                )}

                                {/* Offline */}
                                {paymentMode === 1 && (
                                    <>
                                        <div className="col-lg-12 mb-4">
                                            <label className="text-black font-w500 fs-7">Amount Collected<span className="required">*</span></label>
                                            <input type="text" className="form-control" placeholder="Enter Amount" 
                                                maxLength={10}
                                                value={amount} 
                                                onChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                    setAmount(onlyNums);
                                                }}
                                            />
                                            <span className='text-danger'>{errorsubs.amount}</span>
                                        </div>

                                        <div className="col-lg-12 mb-3">
                                            <label className="text-black font-w500 fs-7">Collected Date<span className="required">*</span></label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                <DatePicker placeholder='Select Date'
                                                    minDate={subDays(new Date(), 7)}
                                                    maxDate={new Date().setHours(23, 59, 59, 999)}
                                                    format="DD-MM-YYYY"
                                                    // value={collectedDate}
                                                    onChange={handleCollectDateChange}
                                                />
                                            </div>
                                            <span className='text-danger'>{errorsubs.collectedDate}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* payment details */}
                        <div className='col-lg-6'>
                            <div className='text-center mb-4'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Payments Details</label>
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-lg-12 d-flex justify-content-between'>
                                    <div className='text-black font-w500 fs-4'>Sub Total</div>
                                    <div>
                                        <label className='text-black font-w500 fs-3'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span>{subtotal}</span>
                                        </label>
                                    </div>
                                </div>

                                <div className='col-lg-12 d-flex justify-content-between'>
                                    <div className='text-black font-w500 fs-5 d-flex align-items-center'>
                                        {!showInput ? (
                                            <>
                                                <label className='text-black font-w500 fs-5'>
                                                    <span>Discount</span>
                                                </label>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Apply Coupon</span></Tooltip>} >
                                                    <span onClick={handleIconClick} className='ms-3' style={{ cursor: 'pointer' }}>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="50"
                                                            id="coupon"
                                                            enableBackground="new 0 0 512 512"
                                                            viewBox="0 0 512 512"
                                                        >
                                                            <path
                                                                fill="#ff4646"
                                                                d="M400,368H48c0-17.673-14.327-32-32-32V112c17.673,0,32-14.327,32-32h352c0,17.673,14.327,32,32,32v224
            C414.327,336,400,350.327,400,368z"
                                                            />
                                                            <path
                                                                fill="#a5c3dc"
                                                                d="M200,328H88c-8.837,0-16-7.163-16-16V200h144v112C216,320.837,208.837,328,200,328z"
                                                            />
                                                            <path
                                                                fill="#e6e6eb"
                                                                d="M120,328H72c-8.837,0-16-7.163-16-16V200h80v112C136,320.837,128.837,328,120,328z"
                                                            />
                                                            <rect width="40" height="16" x="56" y="200" fill="#a5c3dc" />
                                                            <path
                                                                fill="#a5c3dc"
                                                                d="M48,160h176c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                C40,163.582,43.582,160,48,160z"
                                                            />
                                                            <path
                                                                fill="#e6e6eb"
                                                                d="M48,160h88c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                C40,163.582,43.582,160,48,160z"
                                                            />
                                                            <rect width="16" height="128" x="88" y="200" fill="#463c4b" />
                                                            <rect width="16" height="16" x="88" y="200" fill="#32283c" />
                                                            <rect width="16" height="40" x="80" y="160" fill="#463c4b" />
                                                            <rect width="16" height="40" x="176" y="160" fill="#32283c" />
                                                            <rect width="16" height="128" x="168" y="200" fill="#32283c" />
                                                            <path
                                                                fill="#32283c"
                                                                d="M196,104c-15.033,0-29.168,5.854-39.8,16.485L136,140.686l-20.201-20.201C105.168,109.854,91.033,104,76,104
            c-15.439,0-28,12.561-28,28s12.561,28,28,28h120c15.439,0,28-12.561,28-28S211.439,104,196,104z M76,144c-6.617,0-12-5.383-12-12
            s5.383-12,12-12c10.76,0,20.877,4.19,28.485,11.799L116.687,144H76z M196,144h-40.687l12.2-12.201
            C175.123,124.19,185.24,120,196,120c6.617,0,12,5.383,12,12S202.617,144,196,144z"
                                                            />
                                                            <g>
                                                                <rect width="16" height="32" x="256" y="112" fill="#e6e6eb" />
                                                                <rect width="16" height="16" x="256" y="80" fill="#e6e6eb" />
                                                                <rect width="16" height="16" x="256" y="352" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="160" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="208" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="256" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="304" fill="#e6e6eb" />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M320,200c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S333.233,200,320,200z M320,168
            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S324.411,168,320,168z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M384,296c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S397.233,296,384,296z M384,264
            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S388.411,264,384,264z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M319.994,296.002c-1.203,0-2.423-0.272-3.572-0.846c-3.951-1.976-5.553-6.781-3.577-10.733l64-128
            c1.977-3.952,6.78-5.552,10.733-3.578c3.951,1.976,5.553,6.781,3.577,10.733l-64,128
            C325.754,294.381,322.929,296.002,319.994,296.002z"
                                                                />
                                                            </g>
                                                        </svg>
                                                    </span>
                                                </OverlayTrigger>
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    className='form-control w-125px h-30px me-2 mb-2'
                                                    placeholder='Enter Coupon'
                                                    value={coupon}
                                                    onChange={(e) => setCoupon(e.target.value)}
                                                />

                                            </>
                                        )}
                                    </div>

                                    <div className='text-black font-w500 fs-4 ms-5'>
                                        {!showInput ? (
                                            <>
                                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                            <label>{couponamount}</label>
                                            </>
                                        ) : (
                                            <button className='btn btn-sm btn-secondary mb-2' onClick={handleApplyClick}>
                                                Apply
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {errorMessage && (
                                    <div style={{ color: 'red', marginBottom: '0.5rem'}}>
                                        {errorMessage}
                                    </div>
                                )}

                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <div className='text-black font-w500 fs-5'>
                                        <lable className='text-black font-w500 fs-5'>GST</lable>
                                        <lable className='text-danger font-w600 fs-5 ms-1'>( {gst_percentage}% )</lable>
                                    </div>

                                    {/* inclusive or exclusive inputs */}
                                    <div className='d-flex align-items-center'>
                                        <div className='form-check form-check-inline mb-0'>
                                        <input
                                            className='form-check-input'
                                            type='radio'
                                            name='gstType'
                                            id='exclusiveGst'
                                            value='exclusive'
                                            checked={gstType === 'exclusive'}
                                            onChange={(e) => setGstType(e.target.value)}
                                        />
                                        <label className='form-check-label' htmlFor='exclusiveGst'>
                                            Exclusive
                                        </label>
                                        </div>
                                        <div className='form-check form-check-inline mb-0 ms-2'>
                                        <input
                                            className='form-check-input'
                                            type='radio'
                                            name='gstType'
                                            id='inclusiveGst'
                                            value='inclusive'
                                            checked={gstType === 'inclusive'}
                                            onChange={(e) => setGstType(e.target.value)}
                                        />
                                        <label className='form-check-label' htmlFor='inclusiveGst'>
                                            Inclusive
                                        </label>
                                        </div>
                                    </div>

                                    <div className='text-black font-w500 fs-4'>
                                        <label className='text-black font-w500 fs-4'><i class="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                        <label className='text-black font-w500 fs-4'>{gst}</label>
                                    </div>
                                </div>

                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <label className='text-black font-w500 fs-3'>Total Amount</label>
                                    <div>
                                        <label className='text-danger fw-bold fs-2'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span>{totalAmount}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Link to={'/manage-subscribers'} className="btn btn-sm btn-secondary">Cancel</Link>
                        <Link to={'#'} className="btn btn-sm btn-primary" onClick={ConfirmationModalSinglePackage}>Create Subscription</Link>
                    </div>

                </div>
            </div>

            {/* <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-subscribers'} className="btn btn-sm btn-secondary">Cancel</Link>
                <Link to={'#'} className="btn btn-sm btn-primary" onClick={ConfirmationModalSinglePackage}>Convert Subscriber</Link>
            </div> */}
        </>
    )


}
export default ConvertSubscriber;